import React from "react";
import { useLocation } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb } from "@themesberg/react-bootstrap";

const Header = (props) => {

  const { pathname } = useLocation();

  const {
    title,
    children,
  } = props;

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            {
              pathname.replace("/", "").split("/").map((item, i) => (
                <Breadcrumb.Item key={i} active>{item}</Breadcrumb.Item>
              ))
            }
          </Breadcrumb>
          <h4>
            {title}
          </h4>
        </div>
        <div className="mb-2 mb-md-0">{children}</div>
      </div>
    </>
  );
};

export default Header;
